module.exports = __webpack_public_path__ + "img/logo_mobilecool.c8c959cf.png";